<template>
    <div :class="{'content': true, 'active': isMenuOpen }">
        <transition name="fade" mode="out-in" @beforeLeave="beforeLeave" @enter="enter" @afterEnter="afterEnter">
            <div class="content-loaded" v-if="!finished">
                <div class="titleCourse">
                    <h1>{{course.title}}
                        <div class="breadcrumb" v-if="breadcrumbs.length">
                            <a class="breadcrumbItem" href="#" @click.prevent="$router.push({name: 'home'})" ><font-awesome-icon  icon="home"></font-awesome-icon></a>
                            <div v-if="breadcrumbs.length" class="breadcrumbItem"><font-awesome-icon  icon="angle-double-right"></font-awesome-icon></div>
                            <div class="breadcrumbItem"  v-for="(crumb,i) in breadcrumbs" >
                                <a class="breadcrumbItem" v-if="i !== breadcrumbs.length - 1" :href="crumb.text" @click.prevent="$emit('changeTheme',crumb)">{{crumb.text}}</a>
                                <font-awesome-icon class="breadcrumbItem" v-if="i !== breadcrumbs.length - 1" icon="angle-double-right"></font-awesome-icon>
                                <span v-if="i === breadcrumbs.length - 1">{{crumb.text}}</span>

                            </div>
                        </div>
                    </h1>

                    <div  v-html="previewText"></div>
                </div>

            </div>
        </transition>

        <div class="paginator" v-if="nextTheme">
<!--            <div v-if="previousTheme && previousTheme.id"><a href @click.prevent="changeTheme(previousTheme)"><font-awesome-icon icon="chevron-left"></font-awesome-icon>{{previousTheme.text}}</a></div>-->
<!--            <div v-if="previousTheme && previousTheme.id && nextTheme && nextTheme.id">-</div>-->
<!--            <div v-if="nextTheme && nextTheme.id"><a href @click.prevent="changeTheme(nextTheme)">{{nextTheme.text}} <font-awesome-icon icon="chevron-right"></font-awesome-icon></a></div>-->
            <div v-if="nextTheme && nextTheme.id"><button class="btn btn-lg btn-outline btn-success" @click.prevent="changeTheme(nextTheme)">Continuar <font-awesome-icon icon="chevron-right"></font-awesome-icon> </button></div>
        </div>
        <div v-else class="text-center">
            <transition name="fade" mode="out-in" @beforeLeave="beforeLeave" @enter="enter" @afterEnter="afterEnter">
                <div v-if="finished">
                    <h2>Ya has terminado el curso</h2>
                    <p>Para obtener la certificación haz clic en el botón</p>
                    <button class="btn btn-success btn-lg btn-block" @click="$router.push({name:'certificateRequest',params:{id:$route.params.id}})">Obtén el certificado</button>
                </div>
            </transition>
            <transition name="fade" mode="out-in" @beforeLeave="beforeLeave" @enter="enter" @afterEnter="afterEnter">
                <div v-if="!finished">
                    <button class="btn btn-success btn-lg btn-block" @click="$emit('finish')">Finalizar curso</button>
                </div>
            </transition>

        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'

    let marked = require('marked');

    export default {
        name: "contentData",
        props:{
            content: {
                type: String,
                default: null
            },
            breadcrumb: {
                type: Array,
                default: []
            },
            course: {
                type: Object,
                required: true
            },
            nextTheme: {
                type: Object,
                default: null
            },
            previousTheme: {
                type: Object,
                default: null
            },
            finished:{
                type: Boolean,
                default: false
            }
        },
        watch:{
            breadcrumb: function () {
                this.breadcrumbs = [];
                this.getBreadcrumbsArray();

            }
        },
        computed: {
            previewText() {
                marked.setOptions({
                    renderer: new marked.Renderer(),
                    gfm: true,
                    tables: true,
                    breaks: true,
                    pedantic: false,
                    sanitize: true,
                    smartLists: true,
                    smartypants: false
                });
                return marked(this.content)
            },
            ...mapState(['isMenuOpen'])
        },
        mounted(){
            this.getBreadcrumbsArray();
            // this.breadcrumbs = this.breadcrumb.map((crumb)=>{

            // })
        },
        methods:{
            // next(theme){
            //     this.$emit('changeTheme',theme);
            // },
            // previous(theme){
            //     this.$emit('changeTheme',theme);
            // },
            getTheme: async function(slug){
                let res = await this.$store.dispatch({type: 'getTheme', slug:slug});
                return res;
            },
            changeTheme(theme){
                this.$emit('changeTheme',theme);
            },
            getBreadcrumbsArray(){
                for (let i = 0;i<=this.breadcrumb.length - 1; i++ ){
                    this.getTheme(this.breadcrumb[i]).then((a)=>{this.breadcrumbs.push(a)});
                }
            },
            beforeLeave(element) {
                this.prevHeight = getComputedStyle(element).height;
            },
            enter(element) {
                const { height } = getComputedStyle(element);

                element.style.height = this.prevHeight;

                setTimeout(() => {
                    element.style.height = height;
                });
            },
            afterEnter(element) {
                element.style.height = 'auto';
            },
        },
        data() {
            return {
                breadcrumbs: []
            }
        },


    }

</script>
<style lang="scss">
    .titleCourse{
        >h1{
            font-weight: 300;
            color: #666;
            font-size: 1.8rem;
        }
        .breadcrumb{
            display:flex;
            font-size: 18px * 0.8 ;
            .breadcrumbItem{
                align-content: center;
                margin-right: 0.5em;
                color: #666;
                text-decoration: underline;
                &:last-child{
                    text-decoration: none;
                    color: initial;

                }
            }
        }
    }
    .text-center{
        text-align: center;
    }
</style>